import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Recipe, RecipeCreate, RecipeFilter } from '../data/recipe';

export function createRecipeService(client: AxiosInstance) {
  return createCrudService<Recipe, RecipeCreate, RecipeFilter>(
    client,
    '/restaurant/Recipe',
    'id',
  );
}

export type RecipeService = CrudService<Recipe, RecipeCreate, RecipeFilter>;
